import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, debounceTime, mergeMap, filter } from 'rxjs/operators';
import { Action } from 'redux';
import {
  UpdateTrackOrder,
  UpdateTrackOrderSucess,
  UpdateTrackOrderError,
} from '../action-creators';
import { UPDATE_TRACK_ORDER } from '../actions';
import AppState from '../../state';
import * as tracks from '@webapp/sdk/tracks';

export const updateTracksOrderEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, UpdateTrackOrder>(UPDATE_TRACK_ORDER),
    withLatestFrom(state$),
    filter(
      ([action, state]) => !!state.release.release?.id || !!action.releaseId
    ),
    debounceTime(1000),
    mergeMap(async ([action, state]) => {
      try {
        await tracks.updateOrder(
          state.release.release?.id as string,
          action.orderUpdates
        );

        return new UpdateTrackOrderSucess();
      } catch (err) {
        return new UpdateTrackOrderError(err.message);
      }
    })
  );
